module.exports = __webpack_public_path__ + "static/media/font_medium.bb2690c9.woff";